import { Dropdown, Modal, Button, Col, Row, Space, Typography, message } from "antd";
import PoliciesView from "../components/PoliciesView";
import { useState } from "react";
import { PolicyForm } from "../components/PolicyFormDialog.default";
import PolicyFormDialog from "../components/PolicyFormDialog";
import { Guid } from "guid-typescript";
import { previewCompanyPolicy } from "../repository/data.repository";
import { SearchQuery } from "../code/search-query/search-query";
import { getCompanyPoliciesExport } from "../repository/data.repository";
import Loader from "../controls/Loader";
import { getProblemMessage } from "../utils/http";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

function PoliciesPage() {
  const [modal, contextHolder] = Modal.useModal();
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({
    conditions: [],
  });
  const [policyInputMode, setPolicyInputMode] = useState<
    "add" | "update" | "delete"
  >("add");
  const [policyInputOpen, setPolicyInputOpen] = useState(false);
  const [policyInputValues, setPolicyInputValues] = useState<PolicyForm>(
    {} as any,
  );
  const [triggerView, setTriggerView] = useState(Guid.create().toString());
  const permissions = useSelector(authorizeSelectors.permissions);

  function onSearch(searchQuery: SearchQuery): void {
    setSearchQuery(searchQuery);
  }

  function onPolicyAction(
    mode: "add" | "update" | "delete" | "preview",
    values?: PolicyForm,
  ): void {
    if (mode === "preview") {
      previewCompanyPolicy(values!.uid!)
        .then(() => {})
        .catch((err) => {
          modal.error({
            title: "Couldn't open the policy document",
            content: getProblemMessage(err),
            centered: true,
          });
        });
    } else {
      setPolicyInputMode(mode);
      setPolicyInputOpen(true);
      setPolicyInputValues(values || ({} as any));
    }
  }

  function onPolicyInputFinish(): void {
    setPolicyInputOpen(false);
    setTriggerView(Guid.create().toString());
  }

  function onPolicyInputClose(): void {
    setPolicyInputOpen(false);
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading policies export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });
    getCompanyPoliciesExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => {
        loading.destroy();
      })
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Policies
        </Typography.Title>
        <Space className="flex flex-row">
          <Dropdown.Button
            type="primary"
            disabled={!permissions.can("CompanyPolicies", "create")}

            className={`${!permissions.can("CompanyPolicies", "create") ? "disabled" : ""}`}
            menu={{
              items: [
                {
                  key: "downloadExport",
                  label: "Export to Excel",
                  disabled: !permissions.can("CompanyPolicies", "view"),
                  onClick: onDownloadExport,
                },
              ],
            }}
            onClick={() => onPolicyAction("add")}
          >
            Add Policy
          </Dropdown.Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <PoliciesView
          trigger={triggerView}
          onAction={(key: string, record: any) =>
            onPolicyAction(key as any, record)
          }
          onSearch={onSearch}
        />
      </Col>
      <PolicyFormDialog
        mode={policyInputMode}
        open={policyInputOpen}
        initialValues={policyInputValues}
        onFinish={onPolicyInputFinish}
        onCancel={onPolicyInputClose}
      />
      {contextHolder}
    </Col>
  );
}

export default PoliciesPage;
